module.exports = __webpack_public_path__ + "img/blog-3-1.969f36dd.webp";